<template>
  <div class="is-main-content">
    <listes-actions></listes-actions>
    <tableau-opportunites></tableau-opportunites>
  </div>
</template>

<script>
import ListesActions from '@/components/tableauDeBord/listesActions';
import TableauOpportunites from '@/components/tableauDeBord/tableauOpportunites';

export default {
  name: 'index',
  components: { ListesActions, TableauOpportunites },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tableauDeBord/index.vue